/**
 * Render-functions for the 5 flagship top-level nav items
 * (India · Pulse · Money Flow · Automations · Pro).
 *
 * Returns a map of `id → fn(linkClass, pricing, closeMobile)`. Extracted
 * out of `Navbar.jsx` so the navbar shell can stay focused on layout.
 *
 * `useNavOrder` reorders the keys; the navbar iterates the resulting
 * order and looks each id up in this map.
 */
import { NavLink } from "react-router-dom";
import {
  Activity, IndianRupee, Zap, Sparkles,
} from "lucide-react";

export const TOP_NAV_RENDER = {
  india: (cls, _p, close) => (
    <NavLink
      to="/india"
      className={cls}
      data-testid="nav-india"
      onClick={close}
    >
      India
    </NavLink>
  ),
  riskpulse: (cls, _p, close) => (
    <NavLink
      to="/india-risk-pulse"
      className={cls}
      data-testid="nav-risk-pulse"
      onClick={close}
    >
      <span className="inline-flex items-center gap-1">
        <Activity className="h-3 w-3 text-rp-accent" /> Pulse
      </span>
    </NavLink>
  ),
  moneyflow: (cls, _p, close) => (
    <NavLink
      to="/money-flow"
      className={cls}
      data-testid="nav-money-flow"
      onClick={close}
    >
      <span className="inline-flex items-center gap-1">
        <IndianRupee className="h-3 w-3 text-emerald-300" /> Money Flow
      </span>
    </NavLink>
  ),
  automations: (cls, _p, close) => (
    <NavLink
      to="/automations"
      className={cls}
      data-testid="nav-automations"
      onClick={close}
    >
      <span className="inline-flex items-center gap-1">
        <Zap className="h-3 w-3 text-rp-accent" /> Automations
      </span>
    </NavLink>
  ),
  pro: (cls, pricing, close) => (
    <NavLink to="/pro" className={cls} data-testid="nav-pro" onClick={close}>
      <span className="inline-flex items-center gap-1.5">
        <Sparkles className="h-3 w-3 text-orange-300" />
        Pro
        {!pricing.loading && (
          <span
            className="ml-0.5 rounded-full border border-orange-400/40 bg-orange-400/10 px-1.5 py-0.5 text-[10px] font-mono font-semibold text-orange-300"
            data-testid="nav-pro-price-badge"
          >
            {pricing.monthlyShort}
          </span>
        )}
      </span>
    </NavLink>
  ),
};

export function renderTopNavItem(id, linkClass, pricing, closeMobile) {
  return TOP_NAV_RENDER[id]?.(linkClass, pricing, closeMobile) || null;
}
